import script from "./right-bottom.vue?vue&type=script&setup=true&lang=ts"
export * from "./right-bottom.vue?vue&type=script&setup=true&lang=ts"

import "./right-bottom.vue?vue&type=style&index=0&id=3840f224&scoped=true&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3840f224"]])

export default __exports__